import { create } from "zustand";

// =============================================================================
// Types
// =============================================================================

export interface MockLocation {
  latitude: number;
  longitude: number;
}

// =============================================================================
// Store Interface
// =============================================================================

interface MockLocationStore {
  // State
  mockLocation: MockLocation | null;
  isClickMapActive: boolean;

  // Actions
  setMockLocation: (location: MockLocation | null) => void;
  setClickMapActive: (active: boolean) => void;
  clearMockLocation: () => void;
}

// =============================================================================
// Store
// =============================================================================

export const useMockLocationStore = create<MockLocationStore>((set) => ({
  mockLocation: null,
  isClickMapActive: false,

  setMockLocation: (location) =>
    set({
      mockLocation: location,
      isClickMapActive: false, // Disable click mode after setting
    }),

  setClickMapActive: (active) => set({ isClickMapActive: active }),

  clearMockLocation: () =>
    set({
      mockLocation: null,
      isClickMapActive: false,
    }),
}));
